import {Box} from '@mui/material'
import PropTypes from 'prop-types'
import {
  StyledTitleContainer,
  StyledToolTip,
  StyledIconButton,
  StyledBoxContainer,
  StyledTitle,
  StyledChip,
  StyledClearHistoryIcon,
  StyledChatDownloadIconButton,
  StyledDownloadIcon,
  StyledCloseIcon,
  StyledExpandIcon,
  StyledShrinkIcon
} from '../ChatbotStyles'
import {shouldDisableButtons} from '../helpers'

const ChatHeader = ({
  prismProgram,
  title,
  showFullScreen,
  expandShrinkTooltipOpen,
  setExpandShrinkTooltipOpen,
  handleExpandShrinkFromHook,
  setShowConfirmationDialog,
  handleExportChatHistory,
  handleClose,
  messages,
  showLoader,
  canExport
}) => {
  return (
    <StyledTitleContainer>
      <Box>
        <StyledToolTip
          title={showFullScreen ? 'Shrink' : 'Expand'}
          open={expandShrinkTooltipOpen}
          onOpen={() => setExpandShrinkTooltipOpen(true)}
          onClose={() => setExpandShrinkTooltipOpen(false)}
        >
          <StyledIconButton onClick={handleExpandShrinkFromHook}>
            {showFullScreen ? <StyledShrinkIcon /> : <StyledExpandIcon />}
          </StyledIconButton>
        </StyledToolTip>
      </Box>
      <StyledBoxContainer>
        <StyledTitle data-testid='chat-window-title'>{prismProgram} Agent</StyledTitle>
        <StyledToolTip title={title}>
          <StyledChip size='small' label='Beta' />
        </StyledToolTip>
      </StyledBoxContainer>
      <Box justifyContent={'flex-end'} display={'flex'}>
        <StyledToolTip title='Clear Chat History'>
          <StyledIconButton
            onClick={() => setShowConfirmationDialog(true)}
            disabled={shouldDisableButtons(messages, showLoader)}
          >
            <StyledClearHistoryIcon />
          </StyledIconButton>
        </StyledToolTip>
        {canExport && (
          <StyledToolTip title='Download Chat Log'>
            <StyledChatDownloadIconButton
              onClick={handleExportChatHistory}
              disabled={shouldDisableButtons(messages, showLoader)}
            >
              <StyledDownloadIcon />
            </StyledChatDownloadIconButton>
          </StyledToolTip>
        )}
        <StyledToolTip title='Close'>
          <StyledIconButton onClick={handleClose}>
            <StyledCloseIcon />
          </StyledIconButton>
        </StyledToolTip>
      </Box>
    </StyledTitleContainer>
  )
}

ChatHeader.propTypes = {
  prismProgram: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  showFullScreen: PropTypes.bool.isRequired,
  expandShrinkTooltipOpen: PropTypes.bool.isRequired,
  setExpandShrinkTooltipOpen: PropTypes.func.isRequired,
  handleExpandShrinkFromHook: PropTypes.func.isRequired,
  setShowConfirmationDialog: PropTypes.func.isRequired,
  handleExportChatHistory: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired,
  showLoader: PropTypes.bool.isRequired,
  canExport: PropTypes.bool.isRequired
}

export default ChatHeader

/*
CHATBOT HEADER COMPONENT

KEY FUNCTIONS:
- handleExpandShrinkFromHook: Toggles fullscreen/normal window mode
- setShowConfirmationDialog: Opens clear history confirmation
- handleExportChatHistory: Exports chat as PDF
- handleClose: Closes chatbot window

FEATURES:
- Tooltips on all buttons
- Conditional export button based on permissions
- Disabled states during loading
- Responsive layout management
*/
